import React from "react";
import MapPopupContent from "../components/MapPopupContent";

const additionalMarkersConfig = {
  NC500: {
    folder: "/nc500",
    files: ["nc500_route.geojson"],
    layerColors: {
      overnight: '#000022',
      poi: '#555577'
    }
  }
};

export const setupAdditionalMarkers = (mapRef, setPopupContent, setPopupLngLat, showExplorer) => {

  const handleMarkersLoad = () => {
    const params = new URLSearchParams(window.location.search);
    const markerSet = params.get("additional-markers");

    if (!markerSet || !additionalMarkersConfig[markerSet]) {
      return;
    }

    const config = additionalMarkersConfig[markerSet];
    const { folder, files, layerColors } = config;

    files.forEach((file) => {
      fetch(`${folder}/${file}`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`failed to fetch ${file}: ${res.status}`);
          }
          return res.json();
        })
        .then((data) => {
          const sourceId = `${markerSet}-${file}`;
          if (mapRef.current.getSource(sourceId)) return;

          mapRef.current.addSource(sourceId, {
            type: "geojson",
            data,
          });

            // derive styling from geojson; supports feature-agnostic mapStyle
            const {
              lineColor,
              lineOpacity,
              pointRadius,
              pointColor,
              pointOpacity,
            } = data.mapStyle || data.properties.mapStyle || {};

            // line layer (only for LineString features)
            mapRef.current.addLayer({
              id: `${sourceId}-line`,
              type: "line",
              source: sourceId,
              filter: ["==", "$type", "LineString"],
              layout: { "line-join": "round", "line-cap": "round" },
              paint: {
                "line-color": lineColor || '#000000',
                "line-opacity": lineOpacity || 0.5,
                "line-width": 3,
              },
            });

            // point layer rendered as circles
            mapRef.current.addLayer({
              id: `${sourceId}-points`,
              type: "circle",
              source: sourceId,
              filter: ["==", "$type", "Point"],
              paint: {
                "circle-color": pointColor || '#000000',
                "circle-opacity": pointOpacity || 1,
                "circle-radius": pointRadius || 4,
              },
            });

            // make points clickable using MapPopupContent styling
            mapRef.current.on("click", `${sourceId}-points`, (e) => {
              if (e.features && e.features.length) {
                const feature = e.features[0];
                const content = (
                  <MapPopupContent
                    feature={feature}
                    layerColors={layerColors}
                    showExplorer={showExplorer}
                  />
                );
                setPopupContent(content);
                setPopupLngLat(feature.geometry.coordinates);
              }
            });

            mapRef.current.on("mouseenter", `${sourceId}-points`, () => {
              mapRef.current.getCanvas().style.cursor = "pointer";
            });
            mapRef.current.on("mouseleave", `${sourceId}-points`, () => {
              mapRef.current.getCanvas().style.cursor = "";
            });
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.error(`error loading ${markerSet} geojson`, err);
          });
      });
    };

  // Check if map is already loaded
  if (mapRef.current.loaded()) {
    handleMarkersLoad();
  } else {
    mapRef.current.on("load", handleMarkersLoad);
  }
};
